import { createRouter, createWebHistory } from "vue-router";
import Error404 from "../template/views/auth/error/Error404.vue";
import Error500 from "../template/views/auth/error/Error500.vue";
import Login from "../brasal/views/auth/signin/Login.vue";
import RecoverPassword from "../brasal/views/auth/reset/ResetPassword.vue";
import Home from "../brasal/views/pages/Home/Home.vue"

const routes = [
  {
    path: "/authentication/error/error404",
    name: "Error Error404",
    component: Error404
  },
  {
    path: "/authentication/error/error500",
    name: "Error Error500",
    component: Error500
  },

  //Auth Routes
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/login",
    name: "Redirect Login",
    redirect: "/"
  },
  // Recover Password Route
  {
    path: "/password-recover",
    name: "Recuperar Senha",
    component: RecoverPassword,
  },
  // Protected Routes
  {
    path: "/home",
    name: "Minhas Unidades",
    component: Home,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active"
});

export default router;
